export default __webpack_public_path__ + "static/media/simple_mic.d2bacdc5.svg";